import { PROFILES_PATH } from '../../constants'
import { getCurrentIdReduxSelector } from '../../../../redux/selectors/get-current-id'

const getCurrentIdProfileSelect = getCurrentIdReduxSelector(PROFILES_PATH.DATA,
  PROFILES_PATH.CURRENT
)

export default getCurrentIdProfileSelect
